import { Component, EventEmitter, Input, OnInit, Output,NgZone, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { Estatus, IniciativaDetalle, TablaMisIniciativas, UsuarioAutorizado, PriorizacionArea } from '../../../interfaces/interfaces';
import { PaginadoAdiminstrador, PaginadoLider, Paginado } from '../../../models/paginado';
import { DataService } from '../../../services/data.service';
import { AuthService } from '../../../services/auth.service';
import { MatDialog} from '@angular/material/dialog';
import{ ConfirmListadoTablaIniciativasComponent} from 'src/app/components/shared/confirm-listado-tabla-iniciativas/confirm-listado-tabla-iniciativas.component';
import { Router } from '@angular/router';
import { ConfirmacionComponent } from '../../confirmacion/confirmacion.component';
import { HttpClient } from '@angular/common/http';
import { ConfirmDialogComponent } from '../../confirmacion/confirm.component';


//Interface para el filtro de subsecretaria 
export interface EstructuraSub {
  nombre_subsecretariaSap: string;
  id_subsecretariaSap:number;
  estatus_subsecretariaSap:boolean;
}


//Interface para el filtro de tipo de iniciativa 
export interface TipoIniciativa {
  id_tipoIniciativa: number;
  nombre_tipoIniciativa:string;
  estatus_tipoIniciativa:boolean;
}


//Interface para el filtro de aplicaciones
export interface Aplicaciones{
  id_aplicacion: number;
  nombre_aplicacion:string;
  estatus_aplicacion:boolean;
  id_area:number;
}

//Interface para el filtro de enlaces
export interface Enlaces{
  id_usuario: number;
  nombre_usuario:string;
  email_usuario:string;
  id_rol:number;
  nombre_rol:string;
}


//Interface para el filtro de lideres
export interface Lideres{
  id_usuario: number;
  nombre_usuario:string;
  email_usuario:string;
  id_rol:number;
}

//Interface para el filtro de Gestor de Cambios
export interface GestorCambios{
  email_usuario:string;
  id_rol:number;
  idGestorCambios : number;
}

//Interface para el filtro de Analista de TI
export interface AnalistaTI{
  email_usuario:string;
  id_rol:number;
  idAnalistaTI : number;
}



@Component({
  selector: 'app-tabla-iniciativas',
  templateUrl: './tabla-iniciativas.component.html',
  styleUrls: ['./tabla-iniciativas.component.scss']
})
export class TablaIniciativasComponent implements OnInit {
  [x: string]: any;
  // Loading
  loadingFiltro: boolean = true;
  loadingGeneral: boolean = true;
  // Animacion tabla
  pulseAnimacion: string;
  // Cuenta usuario
  @Input() emailUser: string;
  @Input() modoLider: boolean;
  @Input() modoAdmin: boolean;
  @Output() enviarIniciativaModal: EventEmitter<IniciativaDetalle>;
  tablaIniciativas: TablaMisIniciativas[] = [];
  tablaArea:PriorizacionArea[]=[];
  filtrado = false;
  paginaActual: PaginadoAdiminstrador;
  paginaActualFiltros: PaginadoAdiminstrador;
  paginaActualLider: PaginadoLider;
  iniciativaSeleccionada: IniciativaDetalle;
  // Forms para busqueda y validacion
  formBuscarFecha: FormGroup;
  formBuscarFolio: FormGroup;
  formBuscarUsuario: FormGroup;
  formBuscarEstatus: FormGroup;
  formGestoresCambio: FormGroup;
  formAnalistaTi: FormGroup;
  // Usuarios para busqueda
  usuariosBusqueda: UsuarioAutorizado[];
  // Estatus para busqueda
  estatusBusqueda: Estatus;
  // Estatus para inavilitar botons 'Anteriores'
  botonAnteriores: boolean = false;
  priorizar:boolean=false;
  botonPresionado:number;
  userName: string;
  idRolSeleccionado:number;
  fechaInicio:string;
  fechaFin:string;
  consultar: boolean;
  termino:string;
  totalRegistros:number;
  folio:string;
  colorDescriptionButton: string = 'warn';  // Valor inicial del color
  loadingCambioRol:boolean=false;
  varMostraCalendario2021:boolean=false;


  paginaActualPaginado: Paginado;
  accion: string; // Nueva variable para almacenar la acción


  //Usuarios especiales
  jefeAreaDIDS:boolean=false;
  directorDIDS:boolean=false;
  directorDGTIT:boolean=false;
  isLoading:boolean=false;

  //Listado de subsecretaria
  listaSubsecretaria:EstructuraSub[]=[];
  listaTipoIniciativa:TipoIniciativa[]=[];
  listaAplicaciones:Aplicaciones[]=[];
  listaEnlaces:Enlaces[]=[];
  listaLideres:Lideres[]=[];
  listaUR:any[]=[];
  listaEstatus:any[]=[];
  selectedEstatus: number[];
  listFiltroEstatus: any[]=[];
  listaGestoresCambio: GestorCambios[]=[]; //listaGestoresCambio como un array en tu componente.
  listaAnalistaTI: AnalistaTI[]=[]; //Lista de Analista de TI como un array en el componente.
  

  //Variables para filtrado
  selectedValueSub: number;
  selectedValueLider: number;
  selectedValueEnlace: number;
  selectedValueTipo:number;
  selectedValueAplic:number;
  selectedGestorCambio: number;
  selectedAnalistaTI: number | null = null;
  filter:string;
  list:boolean=false;
  listEstatus:boolean=false;
  fechaInicioF:boolean=false;
  fechaEnvio:string;
  ur:number;

  constructor(
    private zone: NgZone,
    private router: Router,
    private dataService: DataService,
    private notifier: NotifierService,
    public dialog:MatDialog,
    private authService: AuthService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef) {
    this.authService.user.subscribe((user: string) => {
      {this.emailUser = user}
      //return this.emailUser;
    });
    this.authService.userName.subscribe((userName: string) => {
      {this.userName = userName}
      //return this.emailUser;
    });
    this.enviarIniciativaModal = new EventEmitter();
    
  }

  ngOnInit() {
    this.cargarSubsecretarias();
    this.cargarTipoIniciativas();
    this.cargarAplicaciones();
    this.cargarEnlaces();
    this.cargarLideres();
    this.cargarUR();
    this.cargarEstatus();
    this.cargarGestoresCambio();
    this.cargarAnalistaTI();

    this.isLoading=true;
    this.authService.escuchaRolSeleccionado().subscribe((res) => {
      this.idRolSeleccionado = res;
     
      if(this.emailUser && this.idRolSeleccionado!=13 && this.idRolSeleccionado!=1 && this.idRolSeleccionado!=2)
      {
        this.isLoading=true;
        this.paginaActualPaginado = new Paginado();
        this.paginaActualPaginado.numeroPagina = 1;
        this.paginaActualPaginado.email=this.emailUser;
        this.paginaActualPaginado.fechaInicio="";
        this.paginaActualPaginado.fechaFin="";
        this.paginaActualPaginado.termino="";
        this.paginaActualPaginado.rolUserlogin=this.idRolSeleccionado;
        this.quitarFiltro();
      }
    });

    this.formBuscarFecha = new FormGroup({
      fechaInicial: new FormControl(''),
      fechaFinal: new FormControl('')
    });
    this.formBuscarFolio = new FormGroup({
      folio: new FormControl('', [Validators.required, Validators.min(1)])
    });
    this.formBuscarUsuario = new FormGroup({
      idUsuario: new FormControl('', [Validators.required])
    });
    this.formBuscarEstatus = new FormGroup({
      idEstatus: new FormControl('', [Validators.required])
    });
    this.formGestoresCambio = new FormGroup({
      idGestorCambio: new FormControl('', [Validators.required])
    });
    this.formAnalistaTI = new FormGroup({
      idAnalistaTI: new FormControl('', [Validators.required])
    });


    this.authService.user.subscribe((user: string) => {
      {this.emailUser = user}
      
    this.paginaActualPaginado = new Paginado();
    this.paginaActualPaginado.botonBuscar=false;
    this.paginaActualPaginado.numeroPagina = 1;
    this.paginaActualPaginado.email=this.emailUser;
    this.paginaActualPaginado.fechaInicio="";
    this.paginaActualPaginado.fechaFin="";
    this.paginaActualPaginado.termino="";
    this.paginaActualPaginado.rolUserlogin=this.idRolSeleccionado;
    if(this.emailUser)
    {
      //Recuperamos el paginado
      let paginadoLocal= JSON.parse(localStorage.getItem('paginado'));
      
      if(paginadoLocal)
      {
        this.paginaActualPaginado=paginadoLocal;
        this.selectedValueTipo=this.paginaActualPaginado.idTipoSolicitud;
        this.selectedValueAplic=this.paginaActualPaginado.idAplicacion;
        //this.selectedValueEnlace=this.paginaActualPaginado.idEnlace;
        //this.selectedValueLider=this.paginaActualPaginado.idLider;
        this.selectedValueSub=this.paginaActualPaginado.idSubsecretariaSap;
        this.fechaInicio=this.paginaActualPaginado.fechaInicio;
        this.fechaFin=this.paginaActualPaginado.fechaFin;
        this.folio=this.paginaActualPaginado.folio_iniciativa;
        this.filter=this.paginaActualPaginado.termino;
        this.selectedGestorCambio=this.paginaActualPaginado.idGestorCambios;
        //this.selectedGestorCambio=this.paginaActualPaginado.idAnalistaTI;
        this.paginaActualPaginado.idAnalistaTI = this.selectedAnalistaTI ? +this.selectedAnalistaTI : null;
        this.paginaActualPaginado.botonBuscar=true;
      }
     if(this.paginaActualPaginado.idLider)
      {
        //Recuperamos las opciones del lider
        let paginadoLider= JSON.parse(localStorage.getItem('lider'));
        this.selectedValueLider=paginadoLider;
      }
      if(this.paginaActualPaginado.idEnlace)
      {
         //Recuperamos las opciones del enlace
        let paginadoEnlace= JSON.parse(localStorage.getItem('enlace'));
        this.selectedValueEnlace=paginadoEnlace;
      }

      this.cargarIniciativas();
      this.usuariosEspeciales(this.idRolSeleccionado);
    }
    });
    
  }

  atenciopRapidaAction(){

  }

  changeStatus(accion, obj) {
    if(this.idRolSeleccionado==12 || this.idRolSeleccionado==8)
    {
      this.botonPresionado=null;
    }
    else{
      this.botonPresionado=11;
    obj.action = accion;
    const dialogRefEliminar = this.dialog.open(ConfirmacionComponent, {
      width: '420px',
      height: '240px',
      data: obj
    }).afterClosed().subscribe(result => {
      this.botonPresionado=null;
      if (result == true) {
        this.modificarAtencionRapida(obj);
      }
    });
    }
  }

 modificarAtencionRapida(obj){
    let data={
      "id_iniciativa":obj.id_iniciativa,
      "userLogin":this.emailUser,
      "rolUserlogin":this.idRolSeleccionado,
      "Rapida_atencion":(obj.rapida_atencion==0)?1:0
    }
    this.dataService.cambiarAtencion(data).subscribe(res=>{
      this.notifier.notify(
               'success',
               'Se modifico el tipo de atención correctamente.'
             );
             this.cargarIniciativas();
    },err=>{
       this.notifier.notify(
                  'error',
                  'Ha ocurrido un error. Contacta al administrador.'
                );
    });
  }

/*********************************************************************************************/
changeStatuss(accion, obj) {
  this.accion = accion; // Almacena la acción en una variable de clase

  if (this.idRolSeleccionado == 12 || this.idRolSeleccionado == 8) {
    this.botonPresionado = null;
  } else {
    this.botonPresionado = 11;
    obj.action = accion;
    
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '420px',
      height: '240px',
      data: obj
    }).afterClosed().subscribe(result => {
      this.botonPresionado = null;

      if (result === true) {
        this.modificarNormativa(obj);

        // Cambiar el color del botón basado en la acción seleccionada
        if (accion === 'Cambiar a atención normativo') {
          this.colorDescriptionButton = 'warn';  // Cambia a rojo
        } else {
          this.colorDescriptionButton = 'primary'; // Cambia al color original o deseado
        }

        this.cdr.detectChanges(); // Forzar detección de cambios
      }
    });
  }
}
/*********************************************************************************************/

// Método para modificar Normativas
modificarNormativa(obj) {
  let dataa = {
    "id_iniciativa": obj.id_iniciativa,
    "userLogin": this.emailUser,
    "rolUserlogin": this.idRolSeleccionado,
    "Atencion_normativa": (obj.atencion_normativa == 0) ? 1 : 0
  };

  this.dataService.cambiarNormativa(dataa).subscribe(
    res => {
      this.notifier.notify(
        'success',
        'Se modificó el tema normativo correctamente.'
      );
      this.cargarIniciativas(); // Recargar las iniciativas para reflejar el cambio
    },
    err => {
      this.notifier.notify(
        'error',
        'Ha ocurrido un error. Contacta al administrador.'
      );
    }
  );
}

/*********************************************************************************************/

  openConfirmEvaluacionTecnica(accion, obj){
    this.botonPresionado=12;
    obj.action = accion;
    const dialogRefEliminar = this.dialog.open(ConfirmacionComponent, {
      width: '420px',
      height: '240px',
      data: obj
    }).afterClosed().subscribe(result => {
      this.botonPresionado=null;
      if (result == true) {
        this.onEvaluacionTecnica(obj);
      }
    });
  }

  onEvaluacionTecnica(obj){
    let body={
      "id_iniciativa":obj['id_iniciativa'],
      "userLogin":this.emailUser,
      "rolUserlogin":this.idRolSeleccionado,
      "Evaluacion_Tecnica":(obj['evaluacion_tecnica']==0)?1:0,
      }
  this.dataService.evaluacionTecnica(body).subscribe(resp=>{
      if(resp["status"]="OK"){
        this.notifier.notify(
          'success',
          ''+resp['notificaciones']
        );
        this.cargarIniciativas();
      }else{
        this.notifier.notify(
          'error',
          'Ha ocurrido un error. Contacta al administrador.'
        );
      }
      },err=>{
        this.notifier.notify(
          'error',
          'Ha ocurrido un error. Contacta al administrador.'
        );
      });
  }
  
  
  openDesing(accion, obj){
    this.botonPresionado=13;
    obj.action = accion;
    const dialogRefEliminar = this.dialog.open(ConfirmacionComponent, {
      width: '520px',
      height: '240px',
      data: obj
    }).afterClosed().subscribe(result => {
      this.botonPresionado=null;
      if (result == true) {
        this.onOpenDesing(obj);
        
      }
    });
  }

  onOpenDesing(obj){
    let body={
      "id_iniciativa":obj['id_iniciativa'],
      "userLogin":this.emailUser,
      "rolUserlogin":this.idRolSeleccionado,
      "Diseno_Finalizado":(obj['diseno_finalizado']==0)?1:0,
      }
  this.dataService.disenoFinalizada(body).subscribe(resp=>{
      if(resp["status"]="OK"){
        this.notifier.notify(
          'success',
          ''+resp['notificaciones']
        );
        this.cargarIniciativas();
      }else{
        this.notifier.notify(
          'error',
          'Ha ocurrido un error. Contacta al administrador.'
        );
      }
      },err=>{
        this.notifier.notify(
          'error',
          'Ha ocurrido un error. Contacta al administrador.'
        );
      });
  }

  compareEnlace(o1: any, o2: any) {
    if(o1.id_usuario == o2.id_usuario && o1.id_rol == o2.id_rol )
    return true;
    else return false
  }

  compareLider(o1: any, o2: any) {
    if(o1.id_usuario == o2.id_usuario && o1.id_rol == o2.id_rol )
    return true;
    else return false
  }


  get ffc() {
    return this.formBuscarFecha.controls;
  }
  get ffoc() {
    return this.formBuscarFolio.controls;
  }
  get fuc() {
    return this.formBuscarUsuario.controls;
  }
  get fec() {
    return this.formBuscarEstatus.controls;
  }
  get fgc() {
    return this.formGestoresCambio.controls;
  }
  get fgcc() {
    return this.formAnalistaTI.controls;
  }

  mostrarList(bandera:boolean)
  {
    this.list=bandera;
  }
  mostrarListEstatus(bandera:boolean)
  {
    this.listEstatus=bandera;
  }
  mostrarFecha(bandera:boolean){
    this.fechaInicioF=bandera;
  }
 
  //Método para cargar las subsecretarias
  cargarSubsecretarias()
  {
    this.dataService.getListSubsecretarias().subscribe(
      data => {
        this.listaSubsecretaria = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }

  
  //Método para cargar las tipos de iniciativas
  cargarTipoIniciativas()
  {
    this.dataService.getListTipoIniciativas().subscribe(
      data => {
        this.listaTipoIniciativa = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }

  
  //Método para cargar las aplicaciones
  cargarAplicaciones()
  {
    
    this.dataService.getListAplicaciones().subscribe(
      data => {
        this.listaAplicaciones = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }


  
  //Método para cargar los enlaces
  cargarEnlaces()
  {
    
    this.dataService.getListEnlaces().subscribe(
      data => {
        this.listaEnlaces = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }

  
  //Método para cargar los lideres
  cargarLideres()
  {
    this.dataService.getListLideres().subscribe(
      data => {
        this.listaLideres = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }

  //Método para cargar los lideres
  cargarUR()
  {
    this.dataService.getListDireccionesGral().subscribe(
      data => {
        this.listaUR = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }

  //Metodo para carga estatus
  cargarEstatus()
  {
    this.dataService.getListCambioEstatus().subscribe(
      data => {
        this.listaEstatus = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }
/*******************************************************************************************************/
   //Esto lo que hará es llamar al endpoint, obtener la lista de gestores de cambio, 
    //y poblar tu <mat-select> con los nombres e IDs de los gestores.
    //Así cuando el usuario seleccione un Gestor de cambio se mandará ese 
    //valor en la función buscarIniciativas.
    cargarGestoresCambio() {
      this.dataService.getListGestorCambios().subscribe(
        (data: any) => {
          if (data && data['data'] && data['data'].length > 0) {
            this.listaGestoresCambio = data['data'];
          } else {
            console.error("Sin información para realizar petición");
            // Notificación de error o mensaje de advertencia
          }
        },
        (error) => {
          console.error("Error al cargar los gestores de cambios", error);
          // Manejo de la notificación de error
        }
      );
    }    
/*******************************************************************************************************/
//Esto lo que hará es llamar al endpoint, obtener la lista de gestores de cambio, 
    //y poblar tu <mat-select> con los nombres e IDs de los gestores.
    //Así cuando el usuario seleccione un Gestor de cambio se mandará ese 
    //valor en la función buscarIniciativas.
    cargarAnalistaTI() {
      this.dataService.getListAnalistasTI().subscribe(
        (data: any) => {
          if (data && data['data'] && data['data'].length > 0) {
            this.listaAnalistaTI = data['data'];
          } else {
            console.error("Sin información para realizar petición");
            // Notificación de error o mensaje de advertencia
          }
        },
        (error) => {
          console.error("Error al cargar los gestores de cambios", error);
          // Manejo de la notificación de error
        }
      );
    }    
/*******************************************************************************************************/    
  //Método para filtrar por la columna estatus
  filtroColumna()
  {
    if(this.ur)
    {
      this.paginaActualPaginado.id_dirgralSap=this.ur[0];
    }
    //Lista filtro estatus
    if(this.listFiltroEstatus.length > 0)
    {
      this.listFiltroEstatus.splice(0);
    }

  if(this.selectedEstatus)
     {
        this.selectedEstatus.forEach((element)=>{
          let filtroEstatus={
            'id_estatusIniciativa':element,
          }
          this.listFiltroEstatus.push(filtroEstatus);
        });
        this.paginaActualPaginado.listEstatus=this.listFiltroEstatus;
     }
    if(this.fechaEnvio)
    {
      this.paginaActualPaginado.fechaEnvio_iniciativa=this.fechaEnvio;
    }
    this.cargarIniciativas();

  }

  //Método para cancelar el filtro de las columnas
  cancelarFiltroColumna(filtro:number)
  {
    if(filtro==1)
    {
      this.ur=null;
      this.paginaActualPaginado.id_dirgralSap=this.ur;
    }
    if(filtro==3){
      this.selectedEstatus=null;
      this.paginaActualPaginado.listEstatus=this.selectedEstatus;
    }
    if(filtro==2){
      this.fechaEnvio=null;
      this.paginaActualPaginado.fechaEnvio_iniciativa=this.fechaEnvio;
    }
    if(filtro==4){
      this.selectedGestorCambio=null;
      this.paginaActualPaginado.idGestorCambios=this.selectedGestorCambio;
    }
    this.cargarIniciativas();

    if(filtro==5){
      this.selectedAnalistaTI=null;
      this.paginaActualPaginado.idAnalistaTI=this.selectedAnalistaTI;
    }
    this.cargarIniciativas();
  }


  //Método para redirigir a la pantalla según el boton presionado 
  onSubmitReactive(btnId:number, id_iniciativa:number, folio:number,tipoIniciativa?:number,solicitudCancelacion?:number,idGestorCambios?:number, idAnalistaTI?:number)
  {
    this.botonPresionado=btnId;
   //window.localStorage.removeItem ("opcionTabla");
   //window.localStorage.setItem ("opcionTabla", btnId.toString());
    //Opcion de equipo de trabajo iniciativa
    if(this.botonPresionado==1)
    {
      this.equipoTrabajoIniciativa(id_iniciativa, folio);
    }

    
    //Opcion de equipo de trabajo iniciativa
    if(this.botonPresionado==3)
    {
      this.historialIniciativa(id_iniciativa, folio);
    }

    //Opcion de cambio de estatus
    if(this.botonPresionado==4)
    {
      //this.openBottomSheet();
      this.cambioEstatusIniciativa(id_iniciativa, folio, tipoIniciativa, solicitudCancelacion);
    }

    
    //Opcion de cambio de solicitud envio fuera de periodo
    if(this.botonPresionado==5)
    {
      //this.openBottomSheet();
      this.solicitudEnvioPeriodo(id_iniciativa, folio, tipoIniciativa,solicitudCancelacion);
    }

    //Opcion de comentarios iniciativa
    if(this.botonPresionado==10)
    {
       this.comentariosIniciativa(id_iniciativa, folio);
    }
  }

  /*Metodo para mostra la lista de estatus
  openBottomSheet(): void {
    this._bottomSheet.open(CambioEstatus);
  }*/

  //Método para los contactos de la iniciativa
  comentariosIniciativa(id:number, folio:number)
  {
    let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,{data:{id_iniciativa:id,folio:folio,userName:this.userName,email:this.emailUser,idRol:this.idRolSeleccionado,opcion:10,usuarioVip:this.directorDIDS},disableClose:true,width: '900%'});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
          this.loadingGeneral=true;
           //Marcamos como vistos los comentarios
           let valores={
             'id_iniciativa':id,
             'email_usuarioComentario':this.emailUser,
             'id_rol':this.idRolSeleccionado
           }
            this.dataService.marcarVistoComentarios(valores).subscribe(
              data => {
              },
              error => {
                console.error(error);
                this.notifier.notify(
                  'error',
                  'Ha ocurrido un error. Contacta al administrador.'
                );
              }
            );
            this.loadingGeneral=false;
            this.cargarIniciativas();
          this.botonPresionado=0;
        }
        else{
          //Marcamos como vistos los comentarios
          let valores={
            'id_iniciativa':id,
            'email_usuarioComentario':this.emailUser,
            'id_rol':this.idRolSeleccionado
          }
           this.dataService.marcarVistoComentarios(valores).subscribe(
             data => {
             },
             error => {
               console.error(error);
               this.notifier.notify(
                 'error',
                 'Ha ocurrido un error. Contacta al administrador.'
               );
             }
           );

          this.cargarAnteriores();
          this.botonPresionado=0;
          
        }
    });
  }

  
  mostrarCalendario2021()
  {
    this.varMostraCalendario2021=true;    
  }


  //Verificamos si es Jefe de Área DIDS
  esJefeArea()
  {
      this.dataService.obtenerInfoUsuario(this.paginaActualPaginado.email).subscribe(
        data => {
          if (data['objData']['jefeAreaDIDS']==true) 
          {
            //Es jefe de area DIDS
            this.jefeAreaDIDS=true;
          }
          else{
            //No es jefe de area DIDS
            this.jefeAreaDIDS=false;
          }
        }
      );
  }


  //Metodo para ordenar por director de area
  sortingDirArea()
  {
    this.paginaActualPaginado.orderByGeneral=false;
    this.paginaActualPaginado.orderBySubse=true;
    this.paginaActualPaginado.orderByArea=true;
    this.cargarIniciativas();

  }

  //Metodo para ordenar por director de area
  sortingDirGral()
  {
    this.paginaActualPaginado.orderBySubse=false;
    this.paginaActualPaginado.orderByArea=false;
    this.paginaActualPaginado.orderByGeneral=true;
    this.cargarIniciativas();
  }

  //Metodo para ordenar por director de area
  sortingSubsecretario()
  {
    this.paginaActualPaginado.orderBySubse=true;
    this.paginaActualPaginado.orderByArea=false;
    this.paginaActualPaginado.orderByGeneral=false;
    this.cargarIniciativas();
  }

  
  //Verificamos si director de DIDS
  esDirectorDIDS()
  {
      this.dataService.obtenerInfoUsuario(this.paginaActualPaginado.email).subscribe(
        data => {
          if (data['objData']['directorDIDS']==true) 
          {
            //Es director de DIDS
            this.directorDIDS=true;
          }
          else{
            //No es director de DIDS
            this.directorDIDS=false;
          }
        }
      );
  }


  
  //Verificamos si es director gral. de DGTIT
  esDirectorDGTIT()
  {
      this.dataService.obtenerInfoUsuario(this.paginaActualPaginado.email).subscribe(
        data => {
          if (data['objData']['directorDGTIT']==true) 
          {
            //Es DIRECTOR GRAL. DGTIT
            this.directorDGTIT=true;
          }
          else{
            //Es DIRECTOR GRAL. DGTIT
            this.directorDGTIT=false;
          }
        }
      );
  }

  usuariosEspeciales(id_rol:number)
  {
    this.jefeAreaDIDS=false;
    this.directorDGTIT=false;
    this.directorDIDS=false;
    //Jefe de area
    if(id_rol==12)
    {
      this.esJefeArea();
    }
    //Director DGTITI
    if(id_rol==10)
    {
      this.esDirectorDGTIT();
    }

    //Director DIDS
    if(id_rol==9)
    {
      this.esDirectorDIDS();
    }
  }


  //Metodo de cambio de estatus iniciativa
  cambioEstatusIniciativa(id_iniciativa:number, folio:number, tipoIniciativa:number,solicitudCancelacion?:number)
  {
    //Verificamos si tiene solicitud de cancelacion
    if(solicitudCancelacion && (this.idRolSeleccionado==3 || this.idRolSeleccionado==4 ||this.idRolSeleccionado==5))
    {
      
          let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,
            {data:{id_iniciativa:id_iniciativa,opcion:4,folio:folio,tipoIniciativa:tipoIniciativa,email:this.emailUser,
              rol:this.idRolSeleccionado,solicitudCancelacion:solicitudCancelacion},disableClose:true, width: '600px'});
              dialogRef.afterClosed().subscribe(result => {
                //Si autoriza, mostramos otro modal
              if(result==true)
              {

                let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,
                  {data:{id_iniciativa:id_iniciativa,opcion:5,folio:folio,tipoIniciativa:tipoIniciativa,email:this.emailUser,
                    rol:this.idRolSeleccionado,solicitudCancelacion:solicitudCancelacion},disableClose:true, width: '600px'});
                    dialogRef.afterClosed().subscribe(result => {
                    if(result==true)
                    {

                        this.botonPresionado=0;
                        this.cargarIniciativas();
          
                    }
                    else{
                      this.botonPresionado=0;

                    }
                });

              }
              //Si rechazo
              else{
                if(result==false)
                {
                  
                let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,
                  {data:{id_iniciativa:id_iniciativa,opcion:6,folio:folio,tipoIniciativa:tipoIniciativa,email:this.emailUser,
                    rol:this.idRolSeleccionado,solicitudCancelacion:solicitudCancelacion},disableClose:true, width: '600px'});
                    dialogRef.afterClosed().subscribe(result => {
                    if(result==true)
                    {
                        this.botonPresionado=0;
                        this.cargarIniciativas();
                    }
                    else{
                      this.botonPresionado=0;
                    }
                });

                }//cerrar el if
                else{
                  this.botonPresionado=0;

                }
                
              }//cerrar el else
          });

    }//Si no tiene solicitud de cancelacion
    else
    {
      let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,
        {data:{id_iniciativa:id_iniciativa,opcion:4,folio:folio,tipoIniciativa:tipoIniciativa,email:this.emailUser,
          rol:this.idRolSeleccionado,solicitudCancelacion:solicitudCancelacion},disableClose:true, width: '600px'});
          dialogRef.afterClosed().subscribe(result => {
          if(result==false)
          {
            this.botonPresionado=0;

          }
          else{
            this.botonPresionado=0;
            this.cargarIniciativas();
          }
      });
  }

}//cierre de método




  //Metodo de solicitud de envio fuera de periodo de iniciativa
  solicitudEnvioPeriodo(id_iniciativa:number, folio:number, tipoIniciativa:number,solicitudEnvio?:number)
  {
    //Verificamos si tiene solicitud de cancelacion
    if(solicitudEnvio && this.idRolSeleccionado==3)
    {  
          let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,
            {data:{id_iniciativa:id_iniciativa,opcion:7,folio:folio,email:this.emailUser,
              rol:this.idRolSeleccionado,solicitudEnvio:solicitudEnvio},disableClose:true, width: '600px'});
              dialogRef.afterClosed().subscribe(result => {
                //Si autoriza
              if(result==true)
              {
                this.botonPresionado=0;
                this.cargarIniciativas();
              }
              //Si rechazo,mostramos otro modal
              else{

                if(result=="close")
                {
                  this.botonPresionado=0;

                }
                else{
                let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,
                  {data:{id_iniciativa:id_iniciativa,opcion:8,folio:folio,email:this.emailUser,
                    rol:this.idRolSeleccionado,solicitudEnvio:solicitudEnvio},disableClose:true, width: '600px'});
                    dialogRef.afterClosed().subscribe(result => {
                    if(result==true)
                    {
                        this.botonPresionado=0;
                        this.cargarIniciativas();
                    }
                    else{
                      this.botonPresionado=0;
                    }
                });
              }
            }
          });
    }

}//cierre de método
  
  //Metodo de historial de iniciativa
  historialIniciativa(id_iniciativa:number, folio:number)
  {
    let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,{data:{id_iniciativa:id_iniciativa,opcion:3,folio:folio},disableClose:true, width: '1200px'});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
          this.botonPresionado=0;
        }
        else{
          this.botonPresionado=0;
        }
    });

  }
  
  //Método para los contactos de la iniciativa
  equipoTrabajoIniciativa(id:number, folio:number)
  {
    //Si el  Gestor de Análisis y Diseño o Gestor de Cambios y Jefe de Área DIDS
    if(this.idRolSeleccionado==3||this.idRolSeleccionado==4 || this.idRolSeleccionado==5 || (this.idRolSeleccionado==12 && this.jefeAreaDIDS==true))
    {
      this.zone.run(() => this.router.navigate(['./equipo-trabajo']));
    }
    else
    {
      let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,{data:{id_iniciativa:id,folio:folio,userName:this.userName,email:this.emailUser,opcion:1},disableClose:true,width: '800px'});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
          this.botonPresionado=0;
        }
        else{
          this.cargarAnteriores();
          this.botonPresionado=0;
          
        }
  });

    }
}//cierre clase


  verDetallesIniciativa(id: number, tipoIniciativa: string) 
  {
    this.dataService.detalleIniciativa(id).subscribe(
      data => {
        this.iniciativaSeleccionada = data['objData'];
        this.iniciativaSeleccionada.tipoIniciativa = tipoIniciativa;
        this.iniciativaSeleccionada.folio=this.folio;
        const tempImpactos = data['objData'].impactos;
        this.iniciativaSeleccionada.impactos = [];
        this.iniciativaSeleccionada.estatusId=data['objData'].estatusId;
        if (tempImpactos) {
          tempImpactos.split('|').forEach((element: string) => {
            this.iniciativaSeleccionada.impactos.push(this.formarImpacto(element));
          });
        }

        this.enviarIniciativaModal.emit(this.iniciativaSeleccionada);
      },
      error => {
        this.notifier.notify(
          'error',
          'Error al intentar obtener la información de la iniciativa. Verifica tu conexión de red.'
        );
      }
    );
  }

  formarImpacto(impacto: string): { nombreImpacto: string; detalleImpacto: string } {
    const listImpacto: string[] = impacto.trim().split('%');
    return {
      nombreImpacto: listImpacto[0],
      detalleImpacto: listImpacto[1]
    };
  }
  
  cargarIniciativas() 
  {
    this.loadingGeneral = true;
    /*if((this.paginaActualPaginado.termino=='' || !this.paginaActualPaginado.termino) 
       && (this.paginaActualPaginado.fechaInicio=='' || !this.paginaActualPaginado.fechaInicio)
       && (this.paginaActualPaginado.fechaFin=='' || !this.paginaActualPaginado.fechaFin))
    {
      this.paginaActualPaginado.botonBuscar=false;
    }else{
      this.paginaActualPaginado.botonBuscar=true;
    }*/
    this.dataService.obtenerIniciativasUsuario(this.paginaActualPaginado).subscribe(
      data => {
        if (data['errorMessage']) 
        {
          this.notifier.notify('error', 'No se han podido cargar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.')
        }
        else{
          this.tablaIniciativas = data['data'];
          this.totalRegistros=data['total_registros'];
          if(data['data'].length < 1)
          {
            this.loadingGeneral = false;
            this.isLoading=false;
          }else{
            this.loadingGeneral = false;
            this.isLoading=false;

          }

        }
      }
    );
  }

  cargarAnteriores() 
  {
    this.loadingGeneral = true;
    this.paginaActualPaginado.numeroPagina--;
    this.paginaActualPaginado.email=this.emailUser;
      this.dataService.obtenerIniciativasUsuario(this.paginaActualPaginado).subscribe(res => {
        if (res['alert']==1) 
        {
          this.notifier.notify('error', 'No se han podido cargar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.');
        } else {
            this.tablaIniciativas = res['data'];
            //this.paginaActual.numeroPagina--;
        }
        this.loadingGeneral = false;
      });
  }

  cargarSiguientes() 
  {
    this.loadingGeneral = true;
    this.loadingGeneral = true;
    this.paginaActualPaginado.numeroPagina++;
    this.paginaActualPaginado.email=this.emailUser;
      this.dataService.obtenerIniciativasUsuario(this.paginaActualPaginado).subscribe(res => {
        if (res['alert']==1) 
        {
          this.notifier.notify('error', 'No se han podido cargar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.');
        } else {
         
            this.tablaIniciativas = res['data'];
            //this.paginaActual.numeroPagina--;
        }
        this.loadingGeneral = false;
      });


  }

  recargarTabla(recarga: number) {
    this.loadingGeneral = true;

      this.dataService.obtenerTodasIniciativas(this.filtrado ? this.paginaActualFiltros : this.paginaActual).subscribe(
        res => {
          this.tablaIniciativas = res['data'];
          this.loadingGeneral = false;

          if (res['errorMessage']) {
            this.notifier.notify('error', 'No se han podido cargar tus iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.')
          } else {
            this.animarTablaRecargar();
          }
        }
      );
  }

  //Método para limpiar los filtros
  quitarFiltro() {
    localStorage.removeItem('paginado');
    localStorage.removeItem('enlace');
    localStorage.removeItem('lider');

    this.fechaEnvio="";
    this.selectedValueSub=null;
    this.selectedValueEnlace=null;
    this.selectedValueAplic=null;
    this.selectedValueLider=null;
    this.selectedValueTipo=null;
    this.selectedGestorCambio=null;
    this.ur=null;
    this.filter='';
    this.ur=null;
    this.fechaEnvio=null;
    this.selectedEstatus=null;
    this.selectedAnalistaTI=null;
    let termino;
    if(this.paginaActualPaginado.termino)
    {
       termino= this.paginaActualPaginado.termino;
    }
    this.paginaActualPaginado= new Paginado;

    this.fechaFin="";
    this.fechaInicio="";
    this.folio="";
    this.paginaActualPaginado.numeroPagina = 1;
    this.paginaActualPaginado.email=this.emailUser;
    this.paginaActualPaginado.fechaInicio="";
    this.paginaActualPaginado.fechaFin="";
    this.paginaActualPaginado.botonBuscar=false;
    //this.paginaActualPaginado.termino="";
    this.paginaActualPaginado.rolUserlogin=this.idRolSeleccionado;
    
    this.cargarIniciativas();
    this.usuariosEspeciales(this.idRolSeleccionado);
  }

  //Metodo para actualizar el grid
  actualizarGrid()
  {
    this.paginaActualPaginado.numeroPagina = 1;
    this.cargarIniciativas();
  }


  private animarTablaRecargar() {
    this.pulseAnimacion = '';
    this.pulseAnimacion = 'animated pulse';
  }

  //Método para aplicar el filtro 
  applyFilter(event: Event) 
  {
    const filterValue = (event.target as HTMLInputElement).value;
    this.paginaActualPaginado.numeroPagina=1;
    if(filterValue=='')
    {
      this.paginaActualPaginado.termino='';
      this.actualizarGrid();
    }else{
      this.buscarIniciativas(this.paginaActualPaginado.numeroPagina,this.fechaInicio,this.fechaFin,filterValue.trim().toLocaleLowerCase());
    }
  }

  
  detalleIniciativaModal(id:number, id_tipoIniciativa:number)
  {
    this.consultar=true;
    localStorage.removeItem ("editarIniciativaId");
    localStorage.setItem ("editarIniciativaId", id.toString());
    if(!this.botonPresionado)
    {
      this.zone.run(() => this.router.navigate(['./consulta-iniciativa']));
    }
    
  }
  
  buscarIniciativas(pagina: number, fechaInicio: string, fechaFin: string, valor?: string, folio?: string) {
    this.loadingGeneral = true;
    this.paginaActualPaginado.numeroPagina = pagina;
    this.paginaActualPaginado.termino = valor;
    this.paginaActualPaginado.fechaFin = this.fechaFin;
    this.paginaActualPaginado.fechaInicio = this.fechaInicio;
  
    // Nuevos filtros
    this.paginaActualPaginado.idSubsecretariaSap = this.selectedValueSub;
    this.paginaActualPaginado.idTipoSolicitud = this.selectedValueTipo;
    this.paginaActualPaginado.idGestorCambios = this.selectedGestorCambio;
    this.paginaActualPaginado.idAnalistaTI = this.selectedAnalistaTI ? +this.selectedAnalistaTI : null; // Ajuste aquí
  
    // Enlace
    if (this.selectedValueEnlace) {
      this.paginaActualPaginado.idEnlace = this.selectedValueEnlace['id_usuario'];
      this.paginaActualPaginado.idRol_enlace = this.selectedValueEnlace['id_rol'];
      window.localStorage.setItem("enlace", JSON.stringify(this.selectedValueEnlace));
    }
  
    // Líder
    if (this.selectedValueLider) {
      this.paginaActualPaginado.idLider = this.selectedValueLider['id_usuario'];
      this.paginaActualPaginado.idRol_lider = this.selectedValueLider['id_rol'];
      window.localStorage.setItem("lider", JSON.stringify(this.selectedValueLider));
    }
  
    this.paginaActualPaginado.idAplicacion = this.selectedValueAplic;
    this.paginaActualPaginado.termino = this.filter;
    this.paginaActualPaginado.botonBuscar = true;
  
    if (this.folio) {
      this.paginaActualPaginado.folio_iniciativa = this.folio;
    }
  
    // Paginado
    window.localStorage.setItem("paginado", JSON.stringify(this.paginaActualPaginado));
  
    this.dataService.obtenerIniciativasUsuario(this.paginaActualPaginado).subscribe(res => {
      this.loadingGeneral = false;
      if (res['alert'] == 1) {
        this.notifier.notify('error', 'No se han podido cargar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.');
      } else {
        this.totalRegistros = res['total_registros'];
        this.tablaIniciativas = res['data'];
      }
    });
  }
  
//Método para descargar archivo excel
descargarArchivoExcelIniciativas()
{
    this.dataService.descargarArchivoIniciativas(this.paginaActualPaginado).subscribe(res => {
        let newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);

       let link = document.createElement('a');
       link.href = data;
       link.download = "Iniciativas_registradas";
       link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

      setTimeout(function () {
        // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });

}
   
}
